import { theme } from "../../theme"

export const cardStyle = {
    position: "relative",
    textAlign: "left",
    backgroundColor: theme.palette.background.paper,
    boxShadow: "rgba(5, 0, 24, 0.2) 0px 5px 16px",
    borderRadius: 4,
    padding: 10,
    marginBottom: 10,
    minWidth: "30vw",
    maxHeight: "44vh",
    resize: "vertical",
    overflow: "scroll",
    transition: "all 0.2s ease-out"
}